import {FaBars, FaChevronDown, FaChevronUp} from "react-icons/fa";
import {NavLink as Link} from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
    background: #fff;
    width: 240px;
    min-width: 240px;
    display: flex;
    flex-direction: column;
    z-index: 12;
    height: 100%;
    border-right: 1px solid #eee;
    padding: 0 20px;
    box-sizing: border-box;
    overflow-y: auto;
`;

export const NavLogo = styled(Link)`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0 12px;
  text-decoration: none;
`;

// Closest freely-available match to the logo's rounded bold wordmark (see
// public/index.html for the Google Fonts import) — the logo image itself
// has its lettering baked in as raster art, not a real font, so this is a
// visual match rather than the literal same font file.
export const NavLogoLabel = styled.span`
  font-family: 'Baloo 2', sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #DA7D46;
  letter-spacing: 0.02em;
  margin-top: 2px;
`;

export const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: ${props => props.$dark ? '#e0e0e0' : '#333'};
  font-weight: 700;
  font-size: 15px;
  padding: 16px 2px;
  border-bottom: 1px solid ${props => props.$dark ? '#222' : '#eee'};
  cursor: pointer;

  svg {
    flex: 0 0 auto;
    color: ${props => props.$dark ? '#888' : '#aaa'};
  }

  &.active {
    color: #DA7D46;
  }

  &.active svg {
    color: #DA7D46;
  }
`;

export const NavItemLabel = styled.span`
  flex: 1;
`;

export const NavExpandToggle = styled.button`
  background: none;
  border: none;
  padding: 4px;
  margin: 0 0 0 auto;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${props => props.$dark ? '#888' : '#aaa'};
`;

export const NavSubMenu = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0 8px 34px;
  border-bottom: 1px solid ${props => props.$dark ? '#222' : '#eee'};
`;

export const NavSubLink = styled(Link)`
  color: ${props => props.$dark ? '#999' : '#888'};
  text-decoration: none;
  font-size: 14px;
  padding: 8px 0;
  cursor: pointer;

  &.active {
    color: #DA7D46;
    font-weight: 600;
  }
`;

export {FaChevronDown, FaChevronUp};

export const Bars = styled(FaBars)`
  display: none;
  color: #fff;
`;

export const NavMenu = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;
`;

export const NavBtnLink = styled(Link)`
  border-radius: 4px;
  background: transparent;
  padding: 10px 22px;
  color: #fff;
  outline: none;
  border: 1px solid #fff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #808080;
  }
`;
